import { BUSINESS_GROUP } from "@helpers/constantes";
import { BusinessGroupDetail } from "@interfaces/response";
import { GrupoEmpresarialValues } from "@interfaces/informacionEmpresa";

/**
 * Formulario → API: `business_group` es texto en mayúsculas ("SI" | "NO") y el detalle va como JSON; sin grupo
 * el detalle se manda en `null`.
 */
export const toBusinessGroupPayload = (values: GrupoEmpresarialValues) => {
  if (values.enGrupoEmpresarial !== "Sí") {
    return { business_group: BUSINESS_GROUP.no, business_group_detail: null };
  }
  const isParent = values.esMatrizGrupo === "Sí";
  const business_group_detail: BusinessGroupDetail = {
    number_of_companies: Number(values.numEmpresasGrupo),
    is_parent_company: isParent,
    parent_company_rfc: isParent ? null : values.rfcMatrizGrupo.trim(),
  };
  return { business_group: BUSINESS_GROUP.si, business_group_detail };
};

/**
 * Formulario → API para PFAE: no aplica grupo empresarial (`"NO"`), y el detalle lleva los años de
 * operación y, si los capturó, los empleados.
 */
export const toPfaeBusinessPayload = (yearsOfOperation: string, employees: string) => ({
  business_group: BUSINESS_GROUP.no,
  business_group_detail: {
    years_of_operation: Number(yearsOfOperation),
    number_of_employees: employees.trim() ? Number(employees) : null,
  } as BusinessGroupDetail,
});

/** API → formulario (PFAE): años de operación y empleados guardados en el detalle. */
export const fromPfaeBusinessResponse = (detail?: BusinessGroupDetail | null) => ({
  yearsOfOperation: detail?.years_of_operation != null ? String(detail.years_of_operation) : "",
  employees: detail?.number_of_employees != null ? String(detail.number_of_employees) : "",
});

/** API → formulario, para prellenar al regresar a la pantalla. */
export const fromBusinessGroupResponse = (
  businessGroup?: string | null,
  detail?: BusinessGroupDetail | null,
): GrupoEmpresarialValues | null => {
  // Se compara en mayúsculas para aceptar también registros guardados en minúsculas.
  const normalized = businessGroup?.trim().toUpperCase();
  if (normalized === BUSINESS_GROUP.no) {
    return { enGrupoEmpresarial: "No", numEmpresasGrupo: "", esMatrizGrupo: "", rfcMatrizGrupo: "" };
  }
  if (normalized !== BUSINESS_GROUP.si) return null;
  return {
    enGrupoEmpresarial: "Sí",
    numEmpresasGrupo: detail?.number_of_companies ? String(detail.number_of_companies) : "",
    esMatrizGrupo: detail ? (detail.is_parent_company ? "Sí" : "No") : "",
    rfcMatrizGrupo: detail?.parent_company_rfc || "",
  };
};
